import React from 'react'
import ScreenerTable from '../Components/Screener/ScreenerTable'

const Screener = () => {
  return (
    <div className='mt-16'>
        <ScreenerTable />
    </div>
  )
}

export default Screener